import { render, staticRenderFns } from "./IdManagerInfoPanel.vue?vue&type=template&id=5dd816ed&scoped=true&"
import script from "./IdManagerInfoPanel.vue?vue&type=script&lang=js&"
export * from "./IdManagerInfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./IdManagerInfoPanel.vue?vue&type=style&index=0&id=5dd816ed&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd816ed",
  null
  
)

export default component.exports